import IconArrowUpRightFromSquareSolid from '@/assets/icons/font_awesome/arrow-up-right-from-square-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { md } from '@/utils/utils_html';
import { DTOWorkspaceCreditTransaction } from '@shared/dto/+workspace/workspace_credit_transaction/dto_workspace_credit_transaction';
import { EWorkspaceCreditTransactonType } from '@shared/dto/+workspace/workspace_credit_transaction/EWorkspaceCreditTransactonType';
import { format_timestamp_YY_MM_DD_HH_mm_ss } from '@shared/utils/utils_time';
import { UserAvatarReadOnly } from '../../_base/UserAvatarReadOnly';

interface Props {
  item: DTOWorkspaceCreditTransaction;
  index: number;
}

export const USListCreditsHistoryItem: React.FC<Props> = ({ item, index }) => {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  /*
   * EVENTS
   */

  function onLinkClicked() {
    window.open(get_url(), '_blank');
  }

  /*
   * METHODS
   */

  function get_class_name() {
    return item.balance_after > item.balance_before ? 'text-green-700' : '';
  }

  function get_url() {
    let out = '';

    if (item.type == EWorkspaceCreditTransactonType.GENERATE_IMAGE) {
      out = ENUM__page_type.BUILD_PATH_GENERATION(item.related_entity_id);
    }

    return out;
  }

  /*
   * RENDERS
   */

  function render_button_open_entity() {
    if (item.type != EWorkspaceCreditTransactonType.GENERATE_IMAGE) return <></>;

    return (
      <UI_PRIMITIVE__button_with_icon_animated
        variant="no-border-on-component"
        size="icon"
        onClick={onLinkClicked}
        iconClassNameBase="!text-component-item-foreground !size-3"
        iconClassNameHovered="!text-bar-foreground"
        Icon={IconArrowUpRightFromSquareSolid}
      />
    );
  }

  /*
   * HTML
   */

  return (
    <div
      className={`${md('px-2 justify-between', 'gap-5 px-5 justify-start')} w-full min-h-[50px] flex flex-row items-center  
      ${index % 2 !== 0 ? 'bg-component-item-selected rounded-lg' : ''}
      ${get_class_name()}
      `}
    >
      <UserAvatarReadOnly url_relative={item.creator_avatar_url_relative} userName={item.creator_name} className="!min-w-9 !min-h-9" />

      <span className={`${md('w-[45px] text-[12px]', 'min-w-[100px]')}  text-left`}>{item.value}</span>
      <span className={`${md('w-[45px] text-[12px]', 'min-w-[120px]')}  text-left`}>{item.balance_before}</span>
      <span className={`${md('w-[45px] text-[12px]', 'min-w-[120px]')}  text-left`}>{item.balance_after}</span>
      <span className={`${md('w-[70px] text-[11px]', 'min-w-[160px]')}  text-left`}>
        {global_is_mobile ? format_timestamp_YY_MM_DD_HH_mm_ss(item.updated_at).split(' ')[0] : format_timestamp_YY_MM_DD_HH_mm_ss(item.updated_at)}
      </span>
      <span className={`${md('w-[45px] text-[12px]', 'min-w-[120px]')}  text-left`}>{item.type}</span>
      {render_button_open_entity()}
    </div>
  );
};
